import { Menu, Typography, Tooltip, Button } from 'antd';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadMergeAPIExploreRecipes } from '../../../../redux/actions/ioc';
import history from '../../../../redux/history';
import { TitleAction } from '../../shared-components/TitleAction';
import { changeTitle } from '../../../../redux/actions/app';
import { ReactComponent as compass_svg } from '../../../../assets/icons/Compass.svg';
import { ReactComponent as description_icon } from '../../../../assets/icons/notes.svg';
import Icon, { PlusOutlined, UserOutlined } from '@ant-design/icons';
import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';
import { ReactComponent as shared_icon } from '../../../../assets/icons/SharedIcon.svg';
import { ReactComponent as public_icon } from '../../../../assets/icons/public.svg';
import cx from 'classnames';
import PermissionLookupTable from '../../../../shared-components/PermissionLookupTable';

export function ExploreSubMenu(props) {
  const ExploreIcon = (props) => <Icon component={compass_svg} />;
  const DescriptionIcon = (props) => (
    <Icon
      style={{ fontSize: '14px' }}
      component={description_icon}
      {...props}
    />
  );

  const dispatch = useDispatch();
  const exploreRecipes = useSelector((state) => state.ioc.exploreRecipes);
  const { Title, Text } = Typography;
  const { isKeyOn, setSessionStorage, toggleKey, ...rest } = props;

  const scopeIconMapping = {
    USER: <UserOutlined />,
    ORGANISATION: <Icon component={shared_icon} />,
    GLOBAL: <Icon component={public_icon} />,
  };

  let recipesToShow = [];
  if (exploreRecipes) {
    recipesToShow = exploreRecipes?.slice(3, -2);
  }

  const navigateToExplore = () => {
    dispatch(changeTitle('Explore', null));
    history.push('/explore');
  };

  const navigateToSavedRecipe = (recipeType, recipeUUID, recipeName) => {
    // props.setSelectedKey(recipeUUID);
    dispatch(changeTitle(recipeName, null));
    history.push(`/explore/${recipeType}` + `?recipeid=${recipeUUID}`);
  };

  const navigateToRecipe = (recipeType, recipeUUID, recipeName) => {
    // props.setSelectedKey(recipeUUID);
    dispatch(changeTitle(recipeName, null));
    history.push(`/explore/${recipeType}` + `?recipeid=${recipeUUID}`);
  };

  return (
    <Menu.SubMenu
      data-cy={`leftMenuSidebarExploreIndicatorDnsData`}
      title={
        <TitleAction
          menuKey={'explore'}
          title={
            <div className={styles.section_title}>
              <div className={styles.border} />
              <ExploreIcon />
              <Title level={5}>Explore DNS Data</Title>
            </div>
          }
          showDownArrow={props.isKeyOn('explore')}
        />
      }
      className={styles.main_menu_option}
      {...rest}
    >
      <Menu.Item
        data-cy="exploreSubMenuExploreIndicatorDnsData"
        onClick={() => {
          navigateToExplore();
          props.setSessionStorage('advanced-search-menu-item');
        }}
        key={'advanced-search-menu-item'}
      >
        <Link to="/explore">
          <Text className={styles.additional_indentation} strong>
            Explore Indicator DNS Data
          </Text>
        </Link>
      </Menu.Item>
      {typeof recipesToShow === 'object' &&
        recipesToShow.map((r, idx) => {
          let menuItems = r.children || [];
          menuItems = menuItems.slice(2);
          return (
            <Menu.SubMenu
              data-cy={`leftMenuSidebar-${r.value}`}
              className={cx(
                styles.first_level_submenu,
                styles.exceptionBackground,
              )}
              key={r.value + '-submenu'}
              onTitleClick={(e) => {
                props.toggleKey(r.value + '-submenu');
              }}
              title={
                <TitleAction
                  menuKey={r.value}
                  titleAction={() => props.toggleKey(r.value)}
                  title={
                    <Text className={styles.additional_indentation} strong>
                      {r.label}
                    </Text>
                  }
                  is_parent={true}
                  itemLabel={r.label}
                />
              }
            >
              <Menu.Item
                onClick={() => {
                  history.push(`/explore/${r.value}`);
                  props.setSessionStorage(r.value);
                }}
                key={r.value}
                disabled={
                  !PermissionLookupTable(r.value, props.mySubscriptionPlan)
                }
              >
                {!PermissionLookupTable(r.value, props.mySubscriptionPlan) ? (
                  props.returnSubstituteMenu({
                    type: 'subMenuButton',
                    tooltipMessage: (
                      <>
                        {r.label} recipe is not part of this subscription plan.
                        To upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    ),
                    menuTitle: (
                      <>
                        Create New <PlusOutlined />
                      </>
                    ),
                    icon: null,
                  })
                ) : (
                  <Tooltip
                    title={'Create New ' + r.label + ' Recipe'}
                    placement="right"
                  >
                    <Link to={`/explore/${r.value}`}>
                      <Button className={styles.add_new_button} type="link">
                        Create New <PlusOutlined />
                      </Button>
                    </Link>
                  </Tooltip>
                )}
              </Menu.Item>

              {menuItems.map((mi, midx) => (
                <Menu.Item
                  data-cy="exploreSubMenuSavedRecipe"
                  onClick={() => {
                    props.setSessionStorage(mi.value);
                  }}
                  key={mi.value + '-savedRecipe'}
                  disabled={
                    !PermissionLookupTable(r.value, props.mySubscriptionPlan)
                  }
                >
                  {!PermissionLookupTable(r.value, props.mySubscriptionPlan) ? (
                    props.returnSubstituteMenu({
                      type: 'innerSubmenuItem',
                      tooltipMessage: (
                        <>
                          {r?.label} is not part of this subscription plan. To
                          upgrade your subscription contact us at{' '}
                          <a target="_blank" href="mailto:sales@silentpush.com">
                            sales@silentpush.com
                          </a>
                          .
                        </>
                      ),
                      menuTitle: (
                        <>
                          <span style={{ marginRight: '4px' }}>
                            {scopeIconMapping[mi.scope]}
                          </span>
                          <span>{mi?.label}</span>
                        </>
                      ),
                      icon: null,
                    })
                  ) : (
                    <TitleAction
                      menuKey={mi.value}
                      title={
                        <Tooltip
                          placement="right"
                          title={mi?.label?.length > 20 ? mi?.label : ''}
                        >
                          <div
                            className={cx(styles.secondary_section_title, {
                              [styles.descriptionAdded]: false,
                            })}
                          >
                            <Link
                              className={styles.additional_indentation}
                              to={
                                `/explore/${r.value}` +
                                `?recipeid=${mi.value}&left_menu_name=${r.label}`
                              }
                            >
                              <span style={{ marginRight: '4px' }}>
                                {scopeIconMapping[mi.scope]}
                              </span>
                              <span>
                                {mi?.label?.length > 20
                                  ? mi?.label?.substr(0, 20) + '...'
                                  : mi?.label}
                              </span>
                            </Link>

                            {/* TODO: Once backend provides description data to the menu */}
                            {/* <div className={styles.recipeDescription}>
                          <Tooltip title={"this is the desc"}>
                            <DescriptionIcon />
                          </Tooltip>
                        </div> */}
                          </div>
                        </Tooltip>
                      }
                    />
                  )}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          );
        })}
    </Menu.SubMenu>
  );
}
